import { contentKeys } from "./keys";
import * as XLSX from "xlsx";
import { FileSpreadsheet } from "lucide-react";
import { Button } from "../components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

const dash = (v) => (v === null || v === undefined ? "–" : v);

const DataTable = ({ cols, rows, testid }) => (
  <div className="overflow-x-auto rounded-lg border border-zinc-800" data-testid={testid}>
    <Table>
      <TableHeader>
        <TableRow className="border-zinc-800 hover:bg-transparent">
          {cols.map(([, label]) => <TableHead key={label} className="whitespace-nowrap bg-zinc-900/60 font-mono text-[10px] uppercase tracking-wider text-zinc-400">{label}</TableHead>)}
        </TableRow>
      </TableHeader>
      <TableBody>
        {contentKeys(rows, (r) => cols.map(([k]) => r[k]).join("|")).map((key, i) => [key, rows[i]]).map(([key, r]) => (
          <TableRow key={key} className="border-zinc-800/70 hover:bg-zinc-800/30">
            {cols.map(([k]) => <TableCell key={k} className={`py-2 text-sm ${typeof r[k] === "number" ? "font-mono tabular-nums text-white" : "text-zinc-300"}`}>{dash(r[k])}</TableCell>)}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

const BOM_COLS = [["item", "Item"], ["spec", "Specification"], ["qty", "Qty"], ["unit", "Unit"], ["length_m", "Length (m)"], ["weight_kg", "Weight (kg)"]];
const CUT_COLS = [["mark", "Mark"], ["profile", "Profile"], ["length_mm", "Length (mm)"], ["qty", "Qty"], ["cut", "Cut"], ["remarks", "Remarks"]];

export default function BomTables({ result, name }) {
  const exportXlsx = () => {
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(result.bom), "BOM");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(result.cutting_list), "Cutting List");
    XLSX.writeFile(wb, `${(name || "design").replace(/\W+/g, "_")}_BOM.xlsx`);
  };
  const totalWeight = result.bom.reduce((s, b) => s + (b.weight_kg || 0), 0);
  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="font-mono text-xs text-zinc-400">Approx. framing + glass weight: <span className="text-white" data-testid="bom-total-weight">{totalWeight.toFixed(0)} kg</span></div>
        <Button data-testid="export-bom-xlsx-btn" size="sm" variant="outline" onClick={exportXlsx} className="border-zinc-700 hover:text-white"><FileSpreadsheet className="mr-2 h-4 w-4" />Export Excel</Button>
      </div>
      <div>
        <h4 className="mb-2 font-[Manrope] font-semibold">Bill of Materials</h4>
        <DataTable cols={BOM_COLS} rows={result.bom} testid="bom-table" />
      </div>
      <div>
        <h4 className="mb-2 font-[Manrope] font-semibold">Cutting List</h4>
        <DataTable cols={CUT_COLS} rows={result.cutting_list} testid="cutting-list-table" />
      </div>
    </div>
  );
}
